import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { CHECKOUT_MODES } from "%/dynamic-component-editor/standard-components/plan-sheet/plan-sheet-state";

// How a Plan Sheet checks out on mobile; the web always takes a card.
export default class CheckoutMode extends BaseOption {
  static userInterfaceComponent = {
    label: "Checkout",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: [
        { name: "Member chooses", id: CHECKOUT_MODES.MEMBER_CHOOSES },
        { name: "App Store only", id: CHECKOUT_MODES.APP_STORE },
        {
          name: "Website only",
          id: CHECKOUT_MODES.WEBSITE,
          warning: "On iPhone, Apple requires the App Store option where paid plans are sold. Website only may be rejected by App Review.",
        },
      ],
    },
  };

  static defaultValue = "member_chooses";
}
